const GovBr = {
    URL_PROVIDER: "https://sso.acesso.gov.br", // URL para autenticação
    URL_SERVICE: "https://api.acesso.gov.br", // URL dos serviços
    REDIRECT_URI: "https://participacao-social.ana.gov.br/Identificado", // URL de retorno depois de autenticar
    SCOPES: "openid+email+phone+profile", // Escopos autorizados
    CLIENT_ID: "participacao-social.ana.gov.br", // ID do cliente fornecido pelo GOV.BR
    SECRET: "ANPj4c_THcSn5EbMVlJTJRcx6qHlzhWZpVcfIQkwD76vtoPXnDkCVf4HSiybln1tj2mZlIr-OUpxK4sUu1PZup8" // Chave secreta fornecida pelo GOV.BR
};
export default GovBr;